import React from 'react';
import BsModal from '../Common/BsModal';


const ConfirmationDialog = ({title, alertDescription, value, notes, show, handleClose, handleConfirm, buttonLabel="Confirm Action", themeClass="danger"}) => {

    if(!show){
        return null;
    }
 

    const confirm = async()=>{
        handleConfirm();
        handleClose();
    }

    return (
        <BsModal
            show={show}
            onClose={handleClose}
            title={title || "Please Confirm"}
            footer={
                <>
                 <button className="btn btn-modern-secondary" onClick={handleClose}>
                    Cancel
                </button>
                <button className={`btn btn-modern-${themeClass || "danger"}`} onClick={confirm}>
                    {buttonLabel}
                </button>
                
                </>
            }
            //size='modal-lg'
        >

            <div className="text-center py-4">
                    <div className="delete-icon-wrapper">
                        <i className="fa-regular fa-circle-question"></i>
                    </div>
                    
                    <h5 className="delete-title">
                        {alertDescription}
                        <span className="user-highlight">{value}</span>
                    </h5>

                    {notes && <div className="delete-note-box">
                        <p className="mb-0">
                            <strong>Note:</strong> {notes}
                        </p>
                    </div>}
                </div>


        </BsModal>
    );
};

export default ConfirmationDialog;
